// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.validate-error-message {\n  color: #e55353;\n  font-size: 80%\n}\n", ""]);
// Exports
module.exports = exports;
